import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { Options } from '../../components/forms/fields/types';
import { Input } from '../TextField/TextField';

interface SimpleSelectProps {
    options: Options[];
    name: string;
    showEmpty?: boolean;
    value: string | null;
    onChange(v: string | null): void;
    required?: boolean;
    label?: string;
}

const SimpleSelect = ({ label, value, options, showEmpty, required, onChange, name }: SimpleSelectProps) => {
    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const stringValue = event.target.value as string;
        const val = stringValue === 'null' ? null : stringValue;
        onChange(val);
    };

    return (
        <FormControl fullWidth margin='normal' required={required}>
            {label
                ? (
                    <InputLabel style={{ marginLeft: '6px' }} shrink htmlFor={name}>
                        {label}
                    </InputLabel>
                ): null}
            <Select
                id={name}
                input={<Input />}
                variant='outlined'
                label={label}
                value={value === null ? 'null' : value}
                onChange={handleChange}
            >
                {showEmpty && (<MenuItem value='null'>&mdash;</MenuItem>)}
                {options.map(({ id, name: optionName }) => (
                    <MenuItem
                        key={id}
                        value={id}
                    >
                        {optionName}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default SimpleSelect;
